import clsx from 'clsx'

import { getUrlFromAvatarImage } from 'components/common/AvatarImage'

interface PartnerLogoProps {
	name: string
	/** Media key relative to VITE_MEDIA_URL. */
	logo?: string | null
	className?: string
}

/** A partner's uploaded logo, or its initial when it has none. */
export function PartnerLogo({ name, logo, className }: Readonly<PartnerLogoProps>) {
	const frame = clsx(
		'flex items-center justify-center overflow-hidden rounded-2xl border border-translucent-plus-border bg-white/[0.04]',
		className ?? 'h-14 w-14'
	)

	if (logo) {
		return (
			<div className={frame}>
				<img src={getUrlFromAvatarImage(logo)} alt={name} className="h-full w-full object-cover" />
			</div>
		)
	}

	return (
		<div className={frame} role="img" aria-label={name}>
			<span className="text-xl font-semibold text-primary-text" aria-hidden="true">
				{name.trim().charAt(0).toUpperCase()}
			</span>
		</div>
	)
}
